import type { ReactNode } from "react";
import { Label } from "@/modern/components/ui/label";
import { VIEW_EDITOR_FIELD_CONTROL_SLOT_CLASS } from "./ViewEditorSection";
import { cn } from "@/modern/utils";

interface ViewEditorFormFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  children: ReactNode;
  className?: string;
}

export const ViewEditorFormField = ({
  label,
  required,
  error,
  children,
  className
}: ViewEditorFormFieldProps) => (
  <div className={cn("space-y-1", className)}>
    <Label className="text-xs font-normal text-muted-foreground">
      {label}
      {required && " *"}
    </Label>
    <div className={cn("w-full", VIEW_EDITOR_FIELD_CONTROL_SLOT_CLASS)}>{children}</div>
    {error && <p className="text-sm text-destructive">{error}</p>}
  </div>
);
